import axios from "./axios"; // Import the centralized Axios instance

const state = {
  cash_bank_accounts: [],
};

const getters = {
  allCashBankAccounts: (state) => state.cash_bank_accounts,
};

const actions = {
  async fetchCashBankAccounts({ commit }) {
    try {
      const response = await axios.get("/cash-bank-account", { params: { page: 1, limit: 25 } });
      commit("setCashBankAccounts", response.data);
    } catch (error) {
      console.error("Failed to fetch cash_bank_accounts:", error);
    }
  },
  async createCashBankAccount({ commit }, cash_bank_account) {
    try {
      const response = await axios.post("/cash-bank-account", cash_bank_account);
      commit("addCashBankAccount", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to create cash_bank_account:", error);
      throw error;
    }
  },
  async fetchCashBankAccountById(_, id) {
    try {
      const response = await axios.get(`/cash-bank-account/${id}`);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch cash_bank_account:", error);
      throw error;
    }
  },
  async updateCashBankAccount({ commit }, cash_bank_account) {
    try {
      const response = await axios.put(`/cash-bank-account/${cash_bank_account.id}`, cash_bank_account);
      commit("updateCashBankAccount", response.data);
    } catch (error) {
      console.error("Failed to update cash_bank_account:", error);
      throw error;
    }
  },
  async deleteCashBankAccountById({ commit }, id) {
    try {
      const response = await axios.delete(`/cash-bank-account/${id}`);
      commit("removeCashBankAccount", id);
      return response.data;
    } catch (error) {
      console.error("Failed to delete cash_bank_account:", error);
      throw error;
    }
  },
};

const mutations = {
  setCashBankAccounts(state, cash_bank_accounts) {
    state.cash_bank_accounts = cash_bank_accounts.data; // Ensure this matches your API's response structure
  },
  addCashBankAccount(state, cash_bank_account) {
    state.cash_bank_accounts.push(cash_bank_account);
  },
  updateCashBankAccount(state, updatedCashBankAccount) {
    const index = state.cash_bank_accounts.findIndex(
      (cash_bank_account) => cash_bank_account.id === updatedCashBankAccount.id
    );
    if (index !== -1) {
      state.cash_bank_accounts.splice(index, 1, updatedCashBankAccount);
    }
  },
  removeCashBankAccount(state, id) {
    state.cash_bank_accounts = state.cash_bank_accounts.filter(
      (cash_bank_account) => cash_bank_account.id !== id
    );
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
